import DashboardPageLink from './DashboardPageLink';

export default DashboardPageLink;
